@layer module {
.access-denied-wrapper {
            grid-area: main-content;
            display: flex;
            flex-flow: column nowrap;
            justify-content: flex-start;
            align-items: center;
            width: 100%;
    }

.access-denied-container {
            display: flex;
            flex-flow: column nowrap;
            align-items: center;
    }
} // layer module










@layer app {
.access-denied-wrapper {
            padding-top: $size-150;
    }

.access-denied-container {
            border-radius: $size-8;
            max-width: $size-350;
            margin-left: auto;
            margin-right: auto;
            padding: $size-30 $size-20;
    }

.access-denied-container .title {
            margin: 0 0 $size-10;
    }

.access-denied-container .headline {
            margin: 0;
    }

.access-denied-container .button-back {
            max-width: $size-400;
            margin-top: $size-30;
    }

      @media (min-width: 500px) {
                .access-denied-container {
                        max-width: $size-500;
                    }
          }

.access-denied-container {
            background: var(--banky-white);
    }

.access-denied-container .title {
            font-size: var(--font-size-xl);
            font-weight: 400;
            line-height: $size-28;
    }

.access-denied-container .headline {
            font-size: var(--font-size-lg);
            font-style: normal;
            font-weight: 400;
            line-height: $size-19;
    }

.access-denied-container .button-back {
            font-size: var(--font-size-lg);
    }
} // layer app
